<template>
    <div :class="boxMsgStyle">
        <div ref="icon_bot" class="bot-icon" v-if="!isUserSend">
            <img :src="styles.avatarBot" alt="robot" style="max-width:24px;max-height:24px;">
        </div>
        <div :class="msgContentStyle" :style="customUI" v-if="msgButton.length === 0">
            <span v-html="replaceLinkInTextContent(msgContent)"></span>
            <buttonReact :message_id="msgId" :user_act="msgReact" v-if="!isUserSend"></buttonReact>
        </div>
        <v-container class="text-box-button pa-0 ma-0" fluid v-else>
            <v-row no-gutters>
                <v-spacer v-if="isUserSend"></v-spacer>
                <v-col sm="6" md="5" lg="4" xl="4">
                    <div class="image-box-content">
                        <div class="img-message-content"
                             :style="customUI"
                             v-if="msgContent !== ''"
                             v-html="replaceLinkInTextContent(msgContent)"></div>
                        <div class="img-button-display" v-if="msgButton.length > 0">
                            <buttonReact :message_id="msgId" :user_act="msgReact" v-if="!isUserSend"></buttonReact>
                            <button 
                                    v-for="(b, i) in msgButton"
                                    :style="[
                                        buttonCustomUI,
                                        buttonHovered === b ? buttonCustomUIHover : {}
                                        ]"
                                    @mouseover="changeButtonHovered(b)"
                                    @mouseleave="changeButtonHovered(-1)"
                                    :key="i"
                                    @click="btn_msg_click(b)">
                                {{ b.title }}
                            </button>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import handlerMessage from '../../business/handler_messages'
import handlerData from '../../business/handler_data'
import buttonReact from './react-button.vue'
import BaseBox from "@/components/ChatBoxElement/BaseBox";

export default {
    name    : 'ChatTextBox',
    extends: BaseBox,
    props   : {
        isFirstMsg: false, // to display style
        isLastMsg : false, // to display style
        isUserSend: false, // to display style
        content   : null, // content, button
        msgId     : '',     // message id
        msgReact  : '',
    },
    components: {
        buttonReact
    },
    data() {
        return {
            msgContent   : '',
            msgButton    : [],
            iconBotCustom: '',
            buttonHovered: -1
        }
    },
    mounted() {
        try {
            this.msgContent = this.content.text
            if (this.content.buttons) {
                // // TODO - check type button / remove type webview
                // for (let i = 0; i < this.content.buttons.length; i++) {
                //     if (this.content.buttons[i].webview) {
                //         // is webview - pass
                //         // TODO - handler webview button
                //     } else {
                //         this.msgButton.push(this.content.buttons[i])
                //     }
                // }
                this.msgButton = this.content.buttons
            } else {
                this.msgButton = []
            }
            this.iconBotCustom = this.$store.state.bot_icon
            if (this.iconBotCustom !== '' && !this.isUserSend) {
                this.$refs.icon_bot.setAttribute('style', 'background-image: url(\'' + decodeURIComponent(this.iconBotCustom) + '\'')
            }
        } catch (e) {
            console.log(e)
        }
    },
    methods : {
        btn_msg_click(btn_detail) {
            // console.log(btn_detail);
            if (btn_detail.payload && btn_detail.payload !== '') {
                let send_msg_content = btn_detail.payload
                if (send_msg_content.indexOf('#') >= 0) {
                    send_msg_content += '#' + btn_detail.title
                } else {
                    send_msg_content += '##' + btn_detail.title
                }
                // console.log(send_msg_content)
                handlerMessage.send_message_to_socket('payload', send_msg_content, this.$store.state.subChannel)
            } else if (btn_detail.url && btn_detail.url !== '') {
                // handler url
                handlerData.clickOpenLink(btn_detail.url)
            } else if (btn_detail.phone_call && btn_detail.phone_call !== '') {
                // phone call
                handlerData.clickCallPhone(btn_detail.phone_call)
            } else if (btn_detail.webview && btn_detail.webview !== "") {
                // handler webview
                if (this.$store.state.componentsMainApp) {
                this.$store.state.componentsMainApp.open_webview('', btn_detail.webview);
                }
            }
        },
        replaceLinkInTextContent(content) {
            return handlerData.urlify(content)
        },
        changeButtonHovered(value){
            this.buttonHovered = value
        },
    },
    computed: {
        boxMsgStyle() {
            let st = 'box-msg'
            if (this.isFirstMsg) {
                st = st + ' first-box-msg'
            }
            if (this.isLastMsg) {
                st = st + ' last-box-msg'
            }
            return st
        },
        msgContentStyle() {
            let st = ''
            if (this.isUserSend) {
                st = 'msg-2'
            } else {
                st = 'msg-1'
            }

            if (this.isLastMsg) {
                st = st + ' ' + st + '-lst-msg'
            }
            return st
        }
    }
}
</script>

<style lang="scss" scoped>
    .bot-icon {
        width           : 40px;
        height          : 50px;
        float           : left;
        background-size : 32px;
    }
    .text-box-button {
        width : calc(100% - 43px);
        float : left;
    }
</style>
